import { Container } from 'pixi.js';
import { DebugLog } from './DebugLog.js';

/**
 * Manages game scenes (boot, menu, gameplay, etc).
 * Only one scene is active at a time.
 */
export class SceneManager {
  constructor(app, eventBus, inputManager) {
    this.app = app;
    this.eventBus = eventBus;
    this.inputManager = inputManager;
    this.currentScene = null;
    this.sceneContainer = new Container();
    app.stage.addChild(this.sceneContainer);
  }

  switchTo(scene) {
    const prevName = this.currentScene?.constructor.name || 'none';
    const nextName = scene.constructor.name;
    DebugLog.info('SceneManager', `Switching scene: ${prevName} -> ${nextName}`);

    if (this.currentScene) {
      this.currentScene.destroy();
      this.sceneContainer.removeChildren();
    }

    this.currentScene = scene;
    scene.init();
    this.sceneContainer.addChild(scene.container);

    this.eventBus.emit('sceneChanged', { from: prevName, to: nextName });
  }

  update(dt) {
    if (this.currentScene) {
      this.currentScene.update(dt);
    }
  }
}
